import { useAddRemoveStructs } from 'contexts/structs/hooks/useAddRemoveStructs'
import { Logger } from 'opensolar-sdk'
import { useTranslate } from 'ra-core'
import { useEffect } from 'react'
import { computeReleasePromosForVersionStruct } from './buildReleasePromoDialogs'
import { useOpenSolarVersionStructs } from './useOpenSolarVersionStructs'

const logger = new Logger('OS.ReleasePromos')

const type = 'promo-dialog'

/**
 * Takes 'opensolar-version' structs and spawns the relevant promo dialogs.
 */
export const useReleasePromos = () => {
  const { structs } = useOpenSolarVersionStructs()
  const { add, removeByKey } = useAddRemoveStructs()
  const translate = useTranslate()

  useEffect(() => {
    const currentSpaVersion = window.SPA_VERSION

    if (!currentSpaVersion) {
      logger.info(
        'SPA_VERSION is not defined, will not add release notifications (set `ENV_APP_SPA_VERSION` in LS to test)'
      )
      return
    }
    for (const struct of structs) {
      const osVersion = struct.data
      const { add: toAdd, removeKeys } = computeReleasePromosForVersionStruct(
        struct.key,
        osVersion,
        translate,
        currentSpaVersion
      )
      for (const key of removeKeys) {
        removeByKey(type, key)
      }
      for (const { key, data } of toAdd) {
        add({ key, type, data }, { update: true })
      }
    }
    // Intentionally [structs] only: add/removeByKey are stable from StructsContext; translate is omitted so
    // locale changes do not re-apply promos (release promos follow opensolar-version struct updates).
  }, [structs])
}
